import { JsonProperty } from "./json-property";

export class UserNotification {

    public id : string = '';
    
    public userId : string = '';
    
    public topic : string = '';
    
    public title : string = '';
    
    public description : string = '';

    public isLocalNotification : boolean = false;
    
    @JsonProperty({ toType: 'datetime' })
    public timestamp : Date = new Date();

    // UI helper
    public isInFlight : boolean = false;

}
